import styled from 'styled-components';
import { space } from 'styled-system';
import { themeGet, getTextColor, getPaletteColor, getMediaQuery, getBorderColor } from '@magalu/stereo-ui-styles';
import Text from '../../../atoms/Text';
export const Container = styled.div`
  ${props => getMediaQuery('large')(props)} {
    display: grid;
    grid-template-columns: 3fr 9fr;
    border-bottom: 1px solid;
    border-color: ${props => getBorderColor('light')(props)};
    padding: 17px 0;
  }
`;
export const ServiceOptionsContainer = styled.div`
  ${props => getMediaQuery('large')(props)} {
    display: flex;
    align-items: center;
    border-left: 1px solid;
    border-color: ${props => getBorderColor('light')(props)};
    & label svg {
      align-self: flex-start;
    }
  }
`;
export const LabelComponent = styled(Text)`
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  line-height: ${props => themeGet('lineHeights.input')(props)}em;
  margin: 10px 0;

  ${props => getMediaQuery('large')(props)} {
    margin: 15px 0 0 0;
  }
`;
export const IncludeLabel = styled.span`
  color: ${props => getTextColor('base')(props)};
  font-size: ${props => themeGet('fontSizes.1')(props)}px;
  padding-left: 12px;
`;
export const IncludeDesktopLabel = styled(IncludeLabel)`
  color: ${props => getTextColor('primary')(props)};
  font-size: ${props => themeGet('fontSizes.4')(props)}px;
  font-weight: ${props => themeGet('fontWeights.medium')(props)};
  line-height: ${props => themeGet('lineHeights.fontSize')(props)};
`;
export const LabelContainer = styled.div`
  border-bottom: 1px solid ${props => getPaletteColor('border.light')(props)};
  ${space}
  &:first-child {
    border-top: 1px solid ${props => getPaletteColor('border.light')(props)};
  }

  ${props => getMediaQuery('large')(props)} {
    padding: 0 17px;
    border: none;
    &:first-child {
      border: none;
    }
  }
`;
export const IncludeDesktopContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${IncludeLabel} {
    margin-bottom: 5px;
  }
`;
export const IncludeDesktopHighlight = styled.span`
  color: ${props => getTextColor('primary')(props)};
  font-weight: ${props => themeGet('fontWeights.bold')(props)};
`;